import Vue from "vue";
import VueRouter from "vue-router";
import {
  PAGES_SLICK_ANCHOR_DELAY_MS,
  scrollElementIntoViewBelowFixedHeader,
} from "@/lib/scrollAnchor";
import store from "@/store";
import { RouterJa } from "./ja";
import { RouterEn } from "./en";
import { fetchMghrwcToken } from "@/services/userService";
// Vue.use(VueHead)
Vue.use(VueRouter);
const routes = [
  {
    // 全てにマッチします
    path: "*",
    meta: {
      layout: "login-layout",
      isPublic: true,
    },
    component: () =>
      import(/* webpackChunkName: "Error404" */ "../views/Error404.vue"),
  },
  {
    path: "/logout",
    alias: "/en/logout",
    meta: { isPublic: true },
    component: () =>
      import(/* webpackChunkName: "logout" */ "../views/Logout.vue"),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    meta: {
      type: "website",
      layout: "none",
      isPublic: true,
    },
    // beforeEnter: (to: any, from: any, next: any) => {
    //   if (process.env.VUE_APP_MAINTENANCE === "true") {
    //     next();
    //   } else {
    //     next("/");
    //   }
    // },
    component: () =>
      import(/* webpackChunkName: "maintenance" */ "../views/Maintenance.vue"),
  },
  ...RouterJa,
  {
    path: "/login",
    meta: {
      isPublic: true,
      title: "ログイン画面",
      type: "website",
      layout: "login-layout"
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    beforeEnter: async (to: any, from: any, next: any) => {
      const query = to.query
      if (typeof query.line_id_token !== "undefined") {
        // alert(store.getters["auth/token"]);
        if (store.getters["auth/token"]) {
          await store.dispatch("auth/logout");
        }
        try {
          await store.dispatch("auth/autoLogin", query);
        } catch (error) {
          console.error(error);
        }
        delete query.line_id_token;
        // const lineAccessToken = sessionStorage.getItem("lineAccessToken");
        // alert(`lineAccessToken from sessionStorage: ${lineAccessToken}`);
        // alert(JSON.stringify(store.getters["auth/line"]));
        // alert(`query.line_access_token: ${query.line_access_token}`);
        if (typeof query.line_access_token !== "undefined") {
          delete query.line_access_token;
        }
      }

      // to.meta.lineLogin = 'errorLineToken'
      store.dispatch("head/updateTitle", "ログイン");
      if (store.getters["auth/token"] !== null) {
        if (typeof query.redirect !== "undefined") {
          const redirectUrl = query.redirect;
          delete query.redirect;
          next({
            path: redirectUrl,
            query: query,
            replace: true,
          });
        } else {
          next({ path: "/", replace: true });
        }
      }
      next();
    },
  },
  {
    path: "/bestprice",
    redirect: "/pages/bestprice",
  },
  {
    path: "/commonenq_fin",
    redirect: "/pages/commonenq_fin",
  },
  {
    path: "/line-auth",
    meta: {
      layout: "login-layout",
      isPublic: true,
    },
    component: () =>
      import(/* webpackChunkName: "JaLineAuth" */ "../views/LineAuth.vue"),
  },
  {
    path: "/to-mghrwc",
    meta: {
      layout: "login-layout",
    },
    component: () =>
      import(/* webpackChunkName: "JaToMghrwc" */ "../views/ToMghrwc.vue"),
    // beforeEnter: (to: any, from: any, next: any) => {
    //   const authMghrwc = store.getters['auth/mghrwc']
    //   if (!authMghrwc) {
    //     return next({ path: "/", replace: true });
    //   }
    //   const rawRedirect = to.query.redirect;
    //   const redirectUrl = Array.isArray(rawRedirect) ? rawRedirect[0] : rawRedirect;
    //   if (!redirectUrl) {
    //     store.commit("loaded", true);
    //     return next({ path: "/", replace: true });
    //   }
    //   return next();
    // },
  },
  {
    path: "/mghrwc-sso",
    meta: {
      layout: "login-layout",
      isPublic: true,
    },
    component: () =>
      import(/* webpackChunkName: "Error" */ "../views/Error.vue"),
    props: (route: any) => ({
      status: Number(route.meta.status), // metaからpropsへ渡す
    }),
    beforeEnter: async (to: any, from: any, next: any) => {
      const moveto = to.query.moveto || "menu";
      try {
        const beforeMghrwc = store.getters['auth/mghrwc'];
        if (!beforeMghrwc) {
          throw {
            status: 401,
            message: "MGHRWCと連携されておりません"
          }
        }
        const resUser = await store.dispatch('auth/updateUser');
        if (resUser.mghrwc) {
          throw {
            status: 401,
            message: "MGHRWCとの連携が解除されました"
          }
        }
        const {token, id} = await fetchMghrwcToken({lang: 'ja-JP', action: 'clubno'})
        if (!token || !id) {
          throw {
            status: 500,
            message: "ネットワークエラー"
          }
        }
        const params = {
          flg: 'MOVECMS',
          action: 'clubno',
          foreignSystem: '1E7B9F96-53AA-4D7C-BB66-3E3AF71894FC',
          lng: 'ja-JP',
          id: id,
          token: token,
          moveto: moveto
        }
        const url = `${process.env.VUE_APP_MGHRWC_DOMAIN}/members/dynamic/moveto?${new URLSearchParams(params).toString()}`;
        window.location.replace(url);
      } catch (error) {
        console.error(error);
        to.meta.status = error.status;
        next();
      }
    },
  },
  {
    path: "/error",
    name: "error",
    meta: {
      layout: "login-layout",
      isPublic: true,
    },
    component: () =>
      import(/* webpackChunkName: "Error" */ "../views/Error.vue"),
    props: (route: any) => ({
      status: Number(route.meta.status), // metaからpropsへ渡す
    }),
    beforeEnter: (to: any, from: any, next: any) => {
      const status = Number(to.query.status) // クエリを数値化

      // 許可するステータス
      const allowedStatuses = [400, 401, 500]
      if (allowedStatuses.includes(status)) {
        to.meta.status = status;
        next()
      } else {
        return next({ path: "/", replace: true });
      }
    },
  },
  ...RouterEn,
];



const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const slickDelay = document.querySelector(
            "#pages-container .slick-carousel"
          )
            ? PAGES_SLICK_ANCHOR_DELAY_MS
            : 0;
          setTimeout(() => {
            const el = document.querySelector(to.hash as string) as HTMLElement | null;
            if (el) {
              scrollElementIntoViewBelowFixedHeader(el, "smooth");
            }
            resolve();
          }, slickDelay);
        }, 0);
      });
    }
    return { x: 0, y: 0 };
  },
});

type Data = {
  [key: string]: string;
};

type SplitResult = {
  utm: Data;
  others: Data;
};


router.beforeEach(async (to, from, next) => {
  const $to: any = to;
  let params: Data = {};
  if (process.env.NODE_ENV !== "development" && location.protocol === "http:") {
    location.replace(location.href.replace(/http:/, "https:"));
  }

  const regex = /^\/en($|\/)/;
  if (regex.test(to.fullPath)) {
    store.commit("auth/updateLang", "en");
  } else {
    store.commit("auth/updateLang", "ja");
  }

  // /logout への遷移では認証チェックをスキップし、ルートの beforeEnter に任せる。
  // ここで isLoggedin が 409 等で next(login) すると「Redirected via navigation guard」エラーになるため。
  if (to.path === "/logout" || to.path === "/en/logout") {
    next();
    return;
  }

  store.dispatch("head/updateTitle", $to.meta.title);
  store.dispatch("head/updateDescription", $to.meta.description);
  store.dispatch("head/updateKeywords");
  store.dispatch("head/updateOgSiteName");
  store.dispatch("head/updateOgType", $to.meta.type);
  store.dispatch("head/updateOgUrl", to.fullPath);
  // store.dispatch('head/updateOgImage', to.meta.ogImage);
  store.dispatch("head/updateOgLocale");

  if (typeof $to.query !== "undefined") {
    params = $to.query;
  }
  const result = splitUtm(params);
  const newParams = new URLSearchParams(result.others).toString();
  let redirectPath = `${to.path}${(newParams) ? `?${newParams}` : ''}`
  let langPath = "/" + store.getters["auth/lang"];
  if (store.getters["auth/lang"] === "ja") {
    langPath = "";
  }
  try {
    let isLogin: boolean = await store.dispatch("auth/isLoggedin")
    if (isLogin) {
      next();
      return;
    } 
  } catch (e) {
    console.error('isLoggedin error', e)
    if(e.status === 409) {
      await store.dispatch('auth/logout')
      alert('別の法人アカウントでLINEログインが行われました。\n再度ログインし直してください。');
      next({
        path: langPath + "/login",
        query: { redirect: redirectPath,...result.utm },
      })
    } else {
      next({
        path: '/error',
        query: {status: e.status},
      })
    }
    return;
  }

  if (to.matched.some((page) => page.meta.isPublic)) {
    next();
    return;
  }


  store.commit("loaded", true);

  next({
    path: langPath + "/login",
    query: { redirect: redirectPath,...result.utm },
  });
});

function splitUtm(data: Data): SplitResult {
  const utm: Data = {};
  const others: Data = {};

  for (const [key, value] of Object.entries(data)) {
    if (key.startsWith("utm_")) {
      utm[key] = value;
    } else {
      others[key] = value;
    }
  }

  return { utm, others };
}

router.afterEach((to, from) => {
  if(store.getters["auth/token"] && !store.getters["auth/account"]){
    store.dispatch("auth/updateUser");
  }
  if (store.getters["auth/lang"] === "ja") {
    document.documentElement.lang = "ja";
  } else {
    document.documentElement.lang = "en";
  }
  document.title = store.getters["head/title"];
  document
    .querySelector(`meta[name='description']`)!
    .setAttribute("content", store.getters["head/description"]);
  document
    .querySelector(`meta[name='keywords']`)!
    .setAttribute("content", store.getters["head/keywords"]);
  document
    .querySelector(`meta[property='og:site_name']`)!
    .setAttribute("content", store.getters["head/og_site_name"]);
  document
    .querySelector(`meta[property='og:title']`)!
    .setAttribute("content", store.getters["head/og_title"]);
  document
    .querySelector(`meta[property='og:description']`)!
    .setAttribute("content", store.getters["head/og_description"]);
  document
    .querySelector(`meta[property='og:type']`)!
    .setAttribute("content", store.getters["head/og_type"]);
  // document.querySelector(`meta[property='og:image']`)!.setAttribute('content', store.getters['head/og_image']);
  document
    .querySelector(`meta[property='og:url']`)!
    .setAttribute("content", store.getters["head/og_url"]);
  document
    .querySelector(`meta[property='og:locale']`)!
    .setAttribute("content", store.getters["head/og_locale"]);
  window._satellite.track("common");
  window.gtag("config", process.env.VUE_APP_GAID, {
    custom_map: {
      dimension1: "MembersName",
      dimension2: "searchNoResult",
    },
    page_title: store.getters["head/title"],
    page_path: to.path,
    MembersName: store.getters["auth/name"],
  });
  window.gtag("set", "user_properties", {
    CorpUserType: store.getters["auth/name"],
  });
  window._lt("send", "pv", [process.env.VUE_APP_LINE_TAGID]);
  if (
    to.path !== "/logout" &&
    to.path !== "/en/logout" &&
    store.getters["auth/name"]
  ) {
    // window.gtag('config', 'G-17MV7EM5EZ', {
    //   'user_id': 'USER_ID'
    // })
    // GTMのタグが準備される前は`window.dataLayer`が存在しないため、一度空の配列を代入しておく。(pushもArray prototypeのpushを使う)
    // GTMのタグが準備された後は、GTMに送信する「dataLayerが持っているpushメソッド」が使えるようになる
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   // 'user_id': store.getters["auth/name"],
    //   'CorpName': store.getters["auth/name"],
    //   // user_id: store.getters["auth/name"],
    //   // CorpUserType: store.getters["auth/name"],
    // });
    window.gtag("event", "LoginMember", {
      MembersName: store.getters["auth/name"],
    });
    window.gtag('event', 'page_view', {
      page_title: store.getters["head/title"],
    });
  }
});

export default router;
